import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LayoutUpload from "./AdminProjects";

function AdminDashboard() {
  const navigate = useNavigate();

  const [members, setMembers] = useState([]);
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [editingMember, setEditingMember] = useState(null);
  const [formData, setFormData] = useState({});
  const [transferData, setTransferData] = useState({ memberId: "", targetId: "" });
  const [searchQuery, setSearchQuery] = useState("");
  const [upTeam, setUpTeam] = useState([]);

  // 🔐 Protect route
  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (!token) navigate("/admin/dashboard");
  }, [navigate]);

  // 📌 Fetch members
  useEffect(() => {
    axios.get("https://api.ssvdevelopers.co.in/members").then((res) => {
      setMembers(res.data);
      setFilteredMembers(res.data);
    });
  }, []);

  // 🔍 Search
  useEffect(() => {
    if (!searchQuery) setFilteredMembers(members);
    else {
      const q = searchQuery.toLowerCase();
      setFilteredMembers(
        members.filter(
          (m) =>
            m.Id?.toLowerCase().includes(q) ||
            m.name?.toLowerCase().includes(q) ||
            m.mobileNo?.toLowerCase().includes(q)
        )
      );
    }
  }, [searchQuery, members]);

  // ✏️ Edit handling
  const handleEditClick = (member) => {
    setEditingMember(member._id);
    setFormData(member);
  };

  const handleSave = async () => {
    try {
      await axios.put(`https://api.ssvdevelopers.co.in/members/${editingMember}`, formData);
      setMembers((prev) =>
        prev.map((m) => (m._id === editingMember ? { ...m, ...formData } : m))
      );
      setEditingMember(null);
    } catch (err) {
      alert("Error saving changes");
    }
  };

  // 🔁 Transfer
  const handleTransfer = async () => {
    try {
      const { memberId, targetId } = transferData;
      if (!memberId || !targetId) {
        alert("Both memberId and targetId/company are required");
        return;
      }

      if (targetId.trim().toLowerCase() === "company") {
        const member = members.find((m) => m.Id === memberId);
        if (!member) {
          alert("Member to transfer not found");
          return;
        }

        // Call the PUT endpoint directly to update referenceNo and parent_id to null
        await axios.put(`https://api.ssvdevelopers.co.in/members/${member._id}`, {
          ...member,
          referenceNo: null,
          parent_id: null
        });

        const res = await axios.get("https://api.ssvdevelopers.co.in/members");
        setMembers(res.data);
        setTransferData({ memberId: "", targetId: "" });
        alert("Team transferred to company successfully");
        return;
      }

      const payload = {
        memberId: memberId,
        targetId: targetId
      };
      await axios.post("https://api.ssvdevelopers.co.in/members/transfer", payload);
      const res = await axios.get("https://api.ssvdevelopers.co.in/members");
      setMembers(res.data);
      setTransferData({ memberId: "", targetId: "" });
      alert("Team transferred successfully");
    } catch (err) {
      alert(err.response?.data?.error || "Transfer failed");
    }
  };

  // 👆 View UP TEAM (linked hierarchy)
  const handleViewUpTeam = (member) => {
    const chain = [];
    let currentMember = member;

    // Climb up using parent_id until top (null or not found)
    while (currentMember && currentMember.parent_id) {
      const nextMember = members.find((m) => m._id === currentMember.parent_id);
      if (!nextMember) break; // stop if no parent found
      chain.push(nextMember);
      currentMember = nextMember;
    }

    // Reverse to show from top → down
    setUpTeam(chain.reverse());
  };


  return (
    <div style={{ padding: "20px", fontSize: "14px" }}>
      {/* Home */}
      <div style={{ marginBottom: "15px" }}>
        <button
          onClick={() => navigate("/")}
          style={{
            padding: "6px 12px",
            backgroundColor: "#0d6efd",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          🏠 Home
        </button>
      </div>

      <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>Admin Dashboard</h2>

      {/* Search */}
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px", AlignItems: "center" }}>
        <input
          type="text"
          placeholder="Search by ID, Name, or Mobile..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ padding: "4px", width: "220px", fontSize: "14px" }}
        />
      </div>

      <LayoutUpload />

      {/* Members Table */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <table
          border="1"
          style={{
            width: "1000px",
            textAlign: "center",
            fontSize: "15px",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th>S.No</th>
              <th>Member Id</th>
              <th>Name</th>
              <th>Cader</th>
              <th>Mobile</th>
              <th>Password</th>
              <th>View Up Team</th>
              <th>Edit</th>
            </tr>
          </thead>
          <tbody>
            {filteredMembers.map((m, index) => (
              <tr key={m._id}>
                <td>{index + 1}</td>
                <td>{m.Id}</td>

                {/* NAME */}
                <td>
                  {editingMember === m._id ? (
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({ ...formData, name: e.target.value })
                      }
                    />
                  ) : (
                    m.name
                  )}
                </td>

                {/* CADER */}
                <td>
                  {editingMember === m._id ? (
                    <input
                      type="text"
                      name="cader"
                      value={formData.cader}
                      onChange={(e) =>
                        setFormData({ ...formData, cader: e.target.value })
                      }
                    />
                  ) : (
                    m.cader
                  )}
                </td>

                {/* MOBILE NO */}
                <td>
                  {editingMember === m._id ? (
                    <input
                      type="text"
                      name="mobileNo"
                      value={formData.mobileNo}
                      onChange={(e) =>
                        setFormData({ ...formData, mobileNo: e.target.value })
                      }
                    />
                  ) : (
                    m.mobileNo
                  )}
                </td>

                {/* PASSWORD FIELD (NEW) */}
                <td>
                  {editingMember === m._id ? (
                    <input
                      type="text"
                      name="password"
                      value={formData.password}
                      onChange={(e) =>
                        setFormData({ ...formData, password: e.target.value })
                      }
                    />
                  ) : (
                    m.password
                  )}
                </td>

                {/* VIEW TEAM */}
                <td>
                  <button
                    onClick={() => handleViewUpTeam(m)}
                    style={{
                      padding: "4px 8px",
                      backgroundColor: "#198754",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                    }}
                  >
                    View Up Team
                  </button>
                </td>

                {/* EDIT / SAVE BUTTONS */}
                <td>
                  {editingMember === m._id ? (
                    <>
                      <button onClick={handleSave}>Save</button>
                      <button onClick={() => setEditingMember(null)}>Cancel</button>
                    </>
                  ) : (
                    <button onClick={() => handleEditClick(m)}>Edit</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>

      {/* 🧭 Up Team Section */}
      {upTeam.length > 0 && (
        <div
          style={{
            marginTop: "25px",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#f8f9fa",
          }}
        >
          <h3>⬆️ Up Team Members</h3>
          <table border="1" style={{ width: "500px", textAlign: "center", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Cader</th>
              </tr>
            </thead>
            <tbody>
              {upTeam.map((m) => (
                <tr key={m._id}>
                  <td>{m.name}</td>
                  <td>{m.cader}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Transfer Section */}
      <div
        style={{
          marginTop: "15px",
          border: "1px solid #ccc",
          padding: "8px",
          fontSize: "14px",
        }}
      >
        <h3>Transfer Team</h3>
        <input
          type="text"
          placeholder="Member ID to transfer"
          value={transferData.memberId}
          onChange={(e) => setTransferData((prev) => ({ ...prev, memberId: e.target.value }))}
          style={{ width: "150px", marginRight: "5px", padding: "4px" }}
        />
        <input
          type="text"
          placeholder="Target Member ID (or 'company')"
          value={transferData.targetId}
          onChange={(e) => setTransferData((prev) => ({ ...prev, targetId: e.target.value }))}
          style={{ width: "150px", marginRight: "5px", padding: "4px" }}
        />
        <button onClick={handleTransfer} style={{ padding: "6px 12px" }}>
          Transfer
        </button>
      </div>
    </div>
  );
}

export default AdminDashboard;
